import { render, staticRenderFns } from "./bet-report.vue?vue&type=template&id=24bc91ad&scoped=true&"
import script from "./bet-report.vue?vue&type=script&lang=js&"
export * from "./bet-report.vue?vue&type=script&lang=js&"
import style0 from "./bet-report.vue?vue&type=style&index=0&id=24bc91ad&scoped=true&lang=css&"
import style1 from "./bet-report.vue?vue&type=style&index=1&id=24bc91ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bc91ad",
  null
  
)

export default component.exports